import { z } from 'zod';

import {
    practiceMemberUsageSortBySchema,
    practiceMemberUsageSortDirectionSchema,
} from '@/entities/reporting';

export const reportingSearchSchema = z.object({
    search: z.string().optional().catch(undefined),
    sortBy: practiceMemberUsageSortBySchema.catch('name'),
    sortDirection: practiceMemberUsageSortDirectionSchema.catch('asc'),
});

export type ReportingSearch = z.infer<typeof reportingSearchSchema>;
